import React, { useState, useEffect } from 'react'
import moment from 'moment';
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import MenuItem from '@mui/material/MenuItem';
import { TextValidator, ValidatorForm, SelectValidator, } from 'react-material-ui-form-validator';

const HospitalClaimDetails = (props) => {
  const classes = useStyle();
  const [admissionDate, setAdmissionDate] = useState(props.eventDate);
  const [dischargeDate, setDischargeDate] = useState(props.claimState.discharge_date || '');
  const [numberOfDaysInHospital, setNumberOfDaysInHospital] = useState(props.claimState.number_of_days_in_hospital || '');
  const [hospitalAttended, setHospitalAttended] = useState(props.claimState.hospital_attended || '');
  const [inpatientNumber, setInpatientNumber] = useState(props.claimState.inpatient_number || '');
  const [causeOfHospitilization, setCauseOfHospitilization] = useState(props.claimState.cause_of_hospitilization || '');

  // Helper function to get date constraints
  const getDateConstraints = () => {
    const eventDate = moment(props.eventDate);
    const eventDateStart = eventDate.format('YYYY-MM-DD') + 'T00:00';
    const eventDateEnd = eventDate.format('YYYY-MM-DD') + 'T23:59';
    const maxDischargeDate = moment().add(1, 'day').format('YYYY-MM-DDTHH:mm');
    
    // For discharge date minimum, use admission date if available, otherwise use event date start
    let dischargeMin = eventDateStart;
    if (admissionDate) {
      const admissionMoment = moment(admissionDate);
      if (admissionMoment.isValid()) {
        dischargeMin = moment(admissionDate).add(1, 'hours').format('YYYY-MM-DDTHH:mm'); // Create new moment instance
      }
    }
    
    return {
      admissionMin: eventDateStart,
      admissionMax: eventDateEnd,
      dischargeMin: dischargeMin,
      dischargeMax: maxDischargeDate
    };
  };

  // Add custom validator for 72-hour minimum requirement
  useEffect(() => {
    ValidatorForm.addValidationRule('minimum72Hours', (value) => {
      if (!admissionDate || !dischargeDate) return true;
      const hours = moment(dischargeDate).diff(moment(admissionDate), 'hours');
      return hours >= 72;
    });

    // Add custom validator to ensure admission date is within event date
    ValidatorForm.addValidationRule('withinEventDate', (value) => {
      if (!value || !props.eventDate) return true;
      const admissionMoment = moment(value);
      const eventMoment = moment(props.eventDate);
      
      // Check if admission date is on the same day as event date
      return admissionMoment.isSame(eventMoment, 'day');
    });

    return () => {
      ValidatorForm.removeValidationRule('minimum72Hours');
      ValidatorForm.removeValidationRule('withinEventDate');
    };
  }, [admissionDate, dischargeDate, props.eventDate]);



  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "admissionDate") {
      setAdmissionDate(value)
      props.setAdditionalState("admission_date", value)
    }
    if (name === "dischargeDate") {
      setDischargeDate(value)
      props.setAdditionalState("discharge_date", value)
      props.setAdditionalState("product_code", props.eventData.product_code)
      props.setAdditionalState("policy_start_date", props.eventData.start_date)
    }

  }

  useEffect(() => {
    if (dischargeDate && admissionDate) {
      const hours = hoursInHospital(dischargeDate, admissionDate);
      const days = Math.floor(hours / 24);
      setNumberOfDaysInHospital(days);
      props.setAdditionalState("number_of_days_in_hospital", days)
    }
  }, [dischargeDate, admissionDate]);

  const hoursInHospital = (dischargeDate, admissionDate) => {
    return moment(dischargeDate).diff(moment(admissionDate), 'hours');
  }





  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4>Claim Information For Hospitilization</h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => { }}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>

          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="admissionDate"
              label="Admission Date & Time"
              name='admissionDate'
              value={admissionDate}
              disabled={false}
              onChange={handleChange}
              fullWidth
              type='datetime-local'
              inputProps={{
                min: getDateConstraints().admissionMin,
                max: getDateConstraints().admissionMax,
              }}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              validators={['required', 'withinEventDate']}
              errorMessages={['Please enter admission date and time', 'Admission date must be on the same day as the event date']}
              style={{ width: "100%" }}
            />

            
          </Grid>



          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="dischargeDate"
              label="Discharge Date & Time"
              name='dischargeDate'
              value={dischargeDate}
              disabled={false}
              onChange={handleChange}
              fullWidth
              type='datetime-local'
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              validators={['required', 'minimum72Hours']}
              errorMessages={['Please enter discharge date and time', 'Minimum 72 hours (3 days) hospitalization required']}
              style={{ width: "100%" }}
            />
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="numberOfDaysInHospital"
              style={{ width: "100%" }}
              label="Number Of Days In Hospital (Calculated)"
              name='numberOfDaysInHospital'
              value={numberOfDaysInHospital}
              onChange={handleChange}
              disabled
              variant="outlined"
              // validators={['required', 'minNumber:2', 'maxNumber:28']}  
              // errorMessages={['This field is required', 'number of days in hospital must be 2 to 28', 'number of days in hospital must be 2 to 28']}
              validators={
                props.hasMediCashIllnessBenefit
                  ? ['required', 'minNumber:3', 'maxNumber:28']
                  : ['required', 'minNumber:3', 'maxNumber:28']
              }
              errorMessages={
                props.hasMediCashIllnessBenefit
                  ? ['This field is required', 'Minimum 3 days (72 hours) hospitalization required', 'Maximum 28 days allowed']
                  : ['This field is required', 'Minimum 3 days (72 hours) hospitalization required', 'Maximum 28 days allowed']
              }
            />
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="hospital_attended"
              style={{ width: "100%" }}
              label="Hospital Attended"
              name='hospital_attended'
              value={hospitalAttended}
              type='text'
              onChange={(e) => {
                setHospitalAttended(e.target.value)
                props.setAdditionalState("hospital_attended", e.target.value)
              }}
              variant="outlined"
          
            />
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
            <TextValidator
              id="inpatient_number"
              style={{ width: "100%" }}
              label="Inpatient Number"
              name='inpatient_number'
              type='text'
              value={inpatientNumber}
              onChange={(e) => {
                setInpatientNumber(e.target.value)
                props.setAdditionalState("inpatient_number", e.target.value)
              }}
              variant="outlined"
          
            />
          </Grid>

          <Grid item xs={12} md={3} sm={3}>
             <SelectValidator
              labelId="cause_of_hospitilization"
              id="cause_of_hospitilization"
              value={causeOfHospitilization}
              name='cause_of_hospitilization'
              type="text"
              label="Cause Of Hospitilization"
               onChange={(e) => {
                setCauseOfHospitilization(e.target.value)
                props.setAdditionalState("cause_of_hospitilization", e.target.value)
              }}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please select a cause of hospitalization']}
              style={{ width: "100%" }}
              sx={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.005em",
                color: "#000000",
              }}
            >

              {
                ["Accident", "Illness"].map((cause, index) => {
                  return (
                    <MenuItem
                      key={index}
                      sx={{
                        fontFamily: "Open Sans",
                        fontStyle: "normal",
                        fontWeight: 300,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.005em",
                        color: "#000000",
                      }} value={cause}>{cause}</MenuItem>
                  )

                })
              }


            </SelectValidator>
          </Grid>


        </Grid>


      </ValidatorForm>
    </>
  )
}

export default HospitalClaimDetails
